import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CampingFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M11.1145 8.09418L9.11448 4.74728L10.439 4L12 6.6123L13.561 4L14.8855 4.74728L12.8855 8.09418L20 19.9999H4L11.1145 8.09418ZM12.0574 12.9556L15.3203 18.4868H13.5645L12.0574 15.932L10.5503 18.4868H8.79443L12.0574 12.9556Z"
      />
    </SvgIcon>
  );
});
